import { useState } from 'react'
import { useAdministrativeContext } from '../../../../../../pages/administrativePanel/administrativePanelContext'
import { SelectColor } from '../../colorPaletFromGraphics'
import { FormatMoney } from '../../../formatMoney'
import { InputCheck } from '../../../../../Forms/InputCheck'

import { Container, Gauge, ChannelInformations } from './style'


export function CardSaleChannel({ 
    percentage, 
    typeSale, 
    totalValue, 
    quantity, 
    ticket, 
    gaugeAnimation,
    id,
    currentSalesChannelsLength 
}) {
    const { listSalesChannelsId, setListSalesChannelsId } = useAdministrativeContext()
    const [checked, setChecked] = useState(listSalesChannelsId.some(idChannel => idChannel === id))

    function handleClickCheck() {
        if(currentSalesChannelsLength.length === 1 && checked)
            return

        setChecked(checked => !checked)

        if(!checked)
            setListSalesChannelsId(listSalesChannelsId => [...listSalesChannelsId, id])
        else
            setListSalesChannelsId(listSalesChannelsId => listSalesChannelsId.filter(idChannel => idChannel !== id))
    }

    
    return(
        <Container>

                <InputCheck 
                    className="checkbox"
                    checked={checked}
                    handleClick={handleClickCheck}
                    size={1.2}
                />

                <Gauge 
                    percentage={percentage / 2} 
                    gaugeAnimation={gaugeAnimation}
                    colorBackgroundGauge={SelectColor(percentage * 100)}
                >
                    <div className="gaugeBody">
                        <div className="gaugeFill" />
                        <div className="gaugeCover">
                            <strong>{(percentage * 100).toFixed(1)}%</strong>
                        </div>
                    </div>
                </Gauge>

                <ChannelInformations>
                    <p className="title">{typeSale}</p>

                    <FormatMoney value={totalValue}/>

                    <p>Qtd: {quantity}</p>

                    <div>
                        <p>Ticket:</p> 
                        <FormatMoney value={ticket} />
                    </div>
                </ChannelInformations>

        </Container>
    )
}